import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { ToastService } from "@app/modules/shared/services/message/toast.service";
import { VatGroupsDto } from "@dashboard/modules/application-params/vat-group/model/vat-groups.dto";
import { ExplorerService } from "@app/modules/shared/services/explorer.service";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { BaseForm } from "@app/data/shared/models/base-form.interface";
import { KlAlertService } from "@app/modules/shared/services/message/alert.service";

@Component({
  selector: "kl-new-vat-groups",
  templateUrl: "./vat-group-form.component.html",
})
export class VatGroupFormComponent
  implements OnInit, AfterViewInit, OnDestroy, BaseForm
{
  @ViewChild("VatGroupsForm", { static: true }) private vatGroupsForm;
  @ViewChild("focusElement", { static: true }) private elementFocus: ElementRef;
  @Input() entity: VatGroupsDto = new VatGroupsDto();
  @Input() isReadOnly: boolean;
  @Input() mode: string;
  @Input() tabId: string;
  @Input() modalId: string;
  alertShow: boolean;
  alertType: string;
  alertMessage: string;
  errorShow = false;

  isOpen = true;

  constructor(
    private apiService: ApiService,
    private toastService: ToastService,
    private explorerService: ExplorerService,
    private alertService: KlAlertService,
    private klLoadingService: KlLoadingService
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.elementFocus.nativeElement.focus();
  }

  formChange(event) {
    if (this.tabId) {
      this.explorerService.changeFormStatus({
        tabId: this.tabId,
        changeForm: event,
      });
    }
  }

  clearForm() {
    this.elementFocus.nativeElement.focus();
    this.entity.code = null;
    this.entity.description = "";
  }

  commitSave(action: any) {
    if (this.vatGroupsForm.valid) {
      this.klLoadingService.show("saving");
      switch (action) {
        case "SAVE":
          switch (this.mode) {
            case "add":
              this.apiService.addData("vatgroups", this.entity).subscribe(
                (response) => this.handleResponse(response),
                (error) => this.handleError(error)
              );
              break;
            case "edit":
              this.apiService.updateData("vatgroups", this.entity).subscribe(
                (response) => this.handleResponse(response),
                (error) => this.handleError(error)
              );
              break;
          }
          break;
        case "SAVE_NEW":
          this.apiService.addData("vatgroups", this.entity).subscribe(
            (response) => this.handleNew(response),
            (error) => this.handleError(error)
          );
          break;
      }
    } else {
      this.alertService.error("required_fields_must_be_entered");
    }
  }

  handleResponse(response) {
    this.klLoadingService.hide();
    this.toastService.toastSuccess();
    if (this.tabId) {
      this.formChange(false);
      this.explorerService.closeTab(this.tabId);
    } else if (this.modalId) {
      this.explorerService.closeModal(this);
    }
  }

  handleNew(response) {
    this.alertShow = false;
    this.formChange(false);
    this.klLoadingService.hide();
    this.toastService.toastSuccess();
    this.clearForm();
  }

  handleError(error) {
    this.klLoadingService.hide();
    this.alertService.error(error);
  }

  unlockEntity() {
    this.apiService.unlockData("vatgroups", this.entity.id).subscribe();
  }

  ngOnDestroy() {
    if (this.mode === "edit") {
      this.unlockEntity();
    }
  }
}
